module.exports = __webpack_public_path__ + "img/andy-1.5446a214.png";